import { v3 } from '@adobe/edex/frontend/api/v3';

const baseURL = '/abuse';
const selfURL = `/self`;

export function create(entityID, entityType) {
  return v3.post(baseURL, {
    entityID,
    entityType,
  });
}

export function remove(entityID, entityType) {
  return v3.delete(`${baseURL}/${entityType}/${entityID}`);
}

export function list() {
  return v3.get(`${selfURL}/${baseURL}`);
}
